module.exports = __webpack_public_path__ + "img/line-go.a9f061c0.png";